<template>
  <div id="player"
    ref="player"
    style="position: relative;"
    v-on:mousemove="showControlPanel(true)"
    v-on:mouseout="showControlPanel(false)">

    <img src="../../assets/images/btn_video_play_L.png"
      :style="{
        'position': 'absolute',
        'z-index': 1000,
        'top': '50%',
        'left': '50%',
        'width': playerHeight + 'px',
        'height': playerHeight + 'px',
        'margin-top': (playerHeight / -2) + 'px',
        'margin-left': (playerHeight / -2) + 'px',
        'cursor': 'pointer'
      }" @click="toggle()"
      v-if="video.state === 'stop'" />

    <video ref="video"
      oncontextmenu="return false;"
      :src="video.url"
      @click="toggle()">
    </video>

    <div class="player-control p-0" v-show="!panel.display && video.state === 'playing'">
      <progress-bar :position="video.currentPos"></progress-bar>
    </div>

    <transition name="fade"
      enter-active-class="animated fadeInUp"
      leave-active-class="animated fadeOutDown">
      <div ref="playerControl" class="player-control pt-2" v-show="panel.display || video.state === 'stop'">
        <progress-bar :position="video.currentPos" v-on:seekTo="seekTo"></progress-bar>
        <div class="d-flex justify-content-start pt-2 pb-2">
          <div>
            <button class="btn btn-primary btn-sm" @click="backToBegin()">
              <i class="fa fa-step-backward fa-2x"></i>
            </button>

            <button class="btn btn-primary btn-sm"
              v-show="video.state !== 'playing'"
              @click="play()">
              <i class="fa fa-play fa-2x" aria-label="play"></i>
            </button>

            <button class="btn btn-primary btn-sm"
              v-show="video.state === 'playing'"
              @click="pause()">
              <i class="fa fa-pause fa-2x" aria-label="pause"></i>
            </button>

            <button class="btn btn-primary btn-sm"
              v-bind:class="{ 'svg-red': repeat && repeatIdx >= 0 }"
              @click="repeatSingle()"
              v-if="hasSubtitles">
              <i class="fa fa-redo-alt fa-2x" aria-label="repeat"></i>
            </button>

            <button class="btn btn-primary btn-sm"
              @click="preSubtitle()"
              v-if="hasSubtitles">
              <i class="fa fa-caret-left fa-2x" aria-label="left"></i>
            </button>

            <button class="btn btn-primary btn-sm"
              @click="nextSubtitle()"
              v-if="hasSubtitles">
              <i class="fa fa-caret-right fa-2x" aria-label="right"></i>
            </button>
          </div>

          <div class="ml-auto">
            <span class="btn" style="color: #fff;">{{ duration(video.currentTime) }} | {{ duration(video.duration) }}</span>

            <button class="btn btn-primary btn-sm"
              @click="switchSub('en')"
              v-if="hasSubtitles">
              <template v-if="language === 'En'">
                <img src="../../assets/images/btn_video_en_on.png" v-if="subs.en" />
                <img src="../../assets/images/btn_video_en_off.png" v-else />
              </template>
              <template v-if="language === 'Ja'">
                <img src="../../assets/images/btn_video_jp_on.png" v-if="subs.en" />
                <img src="../../assets/images/btn_video_jp_off.png" v-else />
              </template>
            </button>

            <button class="btn btn-primary btn-sm"
              @click="switchSub('tw')"
              v-if="hasSubtitles">
              <img src="../../assets/images/btn_video_ch_on.png" v-if="subs.tw" />
              <img src="../../assets/images/btn_video_ch_off.png" v-else />
            </button>

            <button class="btn btn-primary btn-sm" @click="fullscreen()" v-if="isSupportFullscreen">
              <span v-show="!isFullscreen"><i class="fa fa-2x fa-expand" aria-label="exit fullscreen"></i></span>
              <span v-show="isFullscreen"><i class="fa fa-2x fa-compress" aria-label="exit fullscreen"></i></span>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  // import 'animate.css'
  import progressBar from './ProgressBar.vue'
  import playerMixin from '../mixins/playerMixin.js'
  const screenfull = require('screenfull')

  export default {

    name: 'player',

    props: {
      language: {
        type: String,
        required: false,
        default: 'En'
      }
    },

    components: {
      progressBar
    },

    mixins: [playerMixin],

    data () {
      return {
        panel: {
          display: true,
          timer: null
        },
        subs: {
          tw: false,
          en: false
        }
      }
    },

    computed: {
      hasSubtitles () {
        return this.subtitles.length > 0
      },

      isSupportFullscreen () {
        if (document.fullscreenEnabled ||
            document.webkitFullscreenEnabled ||
            document.mozFullScreenEnabled ||
            document.msFullscreenEnabled) {
          return true
        }

        return false
      },

      playerHeight () {
        return this.$refs.player && this.$refs.player.clientHeight ? this.$refs.player.clientHeight : 100
      }
    },

    beforeMount () {
      window.addEventListener('keyup', this.handleKeyup)
      window.addEventListener('resize', this.handleResize)
    },

    created () {
      this.$watch('isFullscreen', (val, oldVal) => {
        this.handleResize()
      })
    },

    mounted () {
      this.$nextTick(() => {
        if (this.video.el.addTextTrack &&
            this.hasSubtitles) {
          this.attachSubtitles()
        }

        this.handleResize()
      })
    },

    beforeDestroy () {
      window.clearInterval(this.panel.timer)
      window.removeEventListener('keyup', this.handleKeyup)
      window.removeEventListener('resize', this.handleResize)
    },

    methods: {
      fullscreen () {
        if (screenfull.enabled) {
          screenfull.toggle(this.$refs.player)
          this.isFullscreen = !this.isFullscreen
          this.updateSubs()
        }
      },

      showControlPanel (state) {
        if (this.panel.display !== state || state) {
          let self = this
          let delay = state ? 0 : 700
          delay = (this.panel.display === state && state) ? 3000 : delay
          state = (this.panel.display === state && state) ? false : state

          window.clearTimeout(this.panel.timer)
          this.panel.timer = window.setTimeout(() => {
            self.panel.display = state
            self.handleResize && self.handleResize()
          }, delay)
        }
      },

      handleResize () {
        try {
          let player = this.$refs.player
          let video = this.$refs.video
          let width = player.clientWidth
          let height = player.clientHeight

          // set player height
          if (video.videoWidth >= video.videoHeight) {
            height = width * video.videoHeight / video.videoWidth
          } else {
            width = height * video.videoWidth / video.videoHeight
          }

          player.style.height = this.isFullscreen ? '100%' : height + 'px'

          // check video size is not larger then player
          height = (height > player.clientHeight) ? player.clientHeight : height
          width = (width > player.clientWidth) ? player.clientWidth : width

          video.style.width = width + 'px'
          video.style.height = height + 'px'
          video.style.top = ((player.clientHeight - height) / 2) + 'px'
          video.style.left = ((player.clientWidth - width) / 2) + 'px'
        } catch (error) {
          window.console.log(error)
        }
      },

      attachSubtitles () {
        window.VTTCue = window.VTTCue || window.TextTrackCue
        let trackEn = this.video.el.addTextTrack('subtitles', 'English', 'en')
        let trackCht = this.video.el.addTextTrack('subtitles', 'Chinese (Traditional)', 'zh')
        let trackChtEn = this.video.el.addTextTrack('subtitles', 'Chinese - English', 'zh-en')
        // default hidden
        // trackEn.mode = 'showing' // 'hidden'

        for (let i = 0; i < this.subtitles.length; i++) {
          let sent = this.subtitles[i]
          try {
            trackEn.addCue(new window.VTTCue(sent.timeCode_Normal.begin / 1000, sent.timeCode_Normal.end / 1000, sent.text))
            trackCht.addCue(new window.VTTCue(sent.timeCode_Normal.begin / 1000, sent.timeCode_Normal.end / 1000, sent.text_i18N[0].value))
            trackChtEn.addCue(new window.VTTCue(sent.timeCode_Normal.begin / 1000, sent.timeCode_Normal.end / 1000, sent.text + '\n' + sent.text_i18N[0].value))
          } catch (err) {
            window.console.log(err)
          }
        }
      },

      switchSub (lang) {
        if (this.subs[lang] !== undefined) {
          this.subs[lang] = !this.subs[lang]
        }

        if (this.subs.tw && this.subs.en) {
          this.video.cc = 3
        } else if (this.subs.en) {
          this.video.cc = 1
        } else if (this.subs.tw) {
          this.video.cc = 2
        } else {
          this.video.cc = 0
        }

        // this.video.cc = ++this.video.cc % (this.video.el.textTracks.length + 1)
        this.updateSubs()
      },

      updateSubs () {
        // changed vvt lang
        for (let i = 0; i < this.video.el.textTracks.length; i++) {
          this.video.el.textTracks[i].mode = ((this.video.cc - 1) === i && this.isFullscreen) ? 'showing' : 'hidden'
        }
      },

      handleKeyup (evt) {
        if (evt.keyCode === 32) {
          evt.preventDefault()
          this.toggle()
        } else if (evt.keyCode === 37) {
          this.preSubtitle()
        } else if (evt.keyCode === 39) {
          this.nextSubtitle()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/style/app.scss";

  #player {
    position: relative;
    cursor: default;
    margin: 0;
    padding: 0;
    height: auto;
    width: auto;
    width: 100%;
    height: 100%;
    min-width: 320px;
    min-height: 240px;
    background-color: rgba(0, 0, 0, 0.9);
    overflow: hidden;

    video {
      display: block; // fixed odd bottom space
      cursor: default;
      margin: auto;
      position: absolute;
      z-index: 100;
    }

    .player-control {
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      position: absolute;
      bottom: 0;
      // width: calc(100% - 4em);
      width: 100%;
      padding-left: 2em;
      padding-right: 2em;
      z-index: 200;
    }

    button {
      background-color: rgba(0, 0, 0, 0);
      border-color: rgba(0, 0, 0, 0);
      padding: 4px;

      &:focus {
        box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.0)!important;
      }

      &.highlight {
        color: red;
      }
    }

    .svg-red {
      svg {
        color: red;
      }
    }
  }

  i {
    &:hover {
      color: #5dceb0;
    }
  }
</style>



// WEBPACK FOOTER //
// Player.vue?1c67decc